import axios from 'axios';
import { PATIENT_APP_URL } from '../app/constants';

export interface IAuthClient {
  confirmEmail(userId: string, code: string): Promise<void>;

  forgotPassword(email: string): Promise<void>;

  resetPassword(email: string, password: string, token: string): Promise<void>;

  confirmChangeEmail(userId: string, email: string, code: string): Promise<void>;
  resendConfirmation(email: string): Promise<void>;
  resendConfirmationForCurrentUser(): Promise<void>;
}

export class AuthClient implements IAuthClient {
  private prefix = '/api';

  public async confirmEmail(userId: string, code: string): Promise<void> {
    await axios({
      method: 'POST',
      url: `${PATIENT_APP_URL}${this.prefix}/confirm/nopassword`,
      data: {
        userId,
        code,
      },
    });
  }

  public async resendConfirmation(email: string): Promise<void> {
    await axios({
      method: 'POST',
      url: `${PATIENT_APP_URL}${this.prefix}/patientapp/resendConfirmation`,
      data: {
        email,
      },
    });
  }

  public async resendConfirmationForCurrentUser(): Promise<void> {
    await axios({
      method: 'POST',
      url: `${PATIENT_APP_URL}${this.prefix}/patientapp/resendConfirmationForCurrentUser`,
    });
  }

  public async forgotPassword(email: string): Promise<void> {
    await axios({
      method: 'POST',
      url: `${PATIENT_APP_URL}${this.prefix}/user/forgotPassword`,
      data: {
        email,
      },
      headers: {
        'Content-Type': 'application/json;',
      },
    });
  }

  public async resetPassword(email: string, password: string, token: string): Promise<void> {
    await axios({
      method: 'POST',
      url: `${PATIENT_APP_URL}${this.prefix}/patientapp/resetPassword`,
      data: {
        email,
        password,
        token,
      },
      headers: {
        'Content-Type': 'application/json;',
      },
    });
  }

  // since generating API client via command in package.json will create a lot of not needed files,
  // we decided to put this here so that we won't implement a new client;
  // it also has one more reason to put it here: changing email is related to logining in ( "auth" stuff :) )
  public async confirmChangeEmail(userId: string, email: string, code: string): Promise<void> {
    await axios({
      method: 'POST',
      url: `${PATIENT_APP_URL}${this.prefix}/confirm/change-email`,
      data: {
        userId,
        email,
        code,
      },
      headers: {
        'Content-Type': 'application/json;',
      },
    });
  }
}

export default AuthClient;
